@if (itemMessage) {
    <h3 class="alert alert-danger">{{ itemMessage }}</h3>
} @else {
    <h3 class="alert alert-light">redirecting to action page...</h3>
}
